module.exports = __webpack_public_path__ + "static/media/battlefield1.7e481547.jpg";